import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Link } from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from '../assets/logo0.png';

const Footer = () => {
  return (
    <>
      <Box sx={{ bgcolor: '#000000', color: '#fff', py: 6 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Quick Links Column */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Quick Links
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Link component={RouterLink} to="/about" color="inherit" sx={{ textDecoration: 'none' }}>
                  About Larrvaries
                </Link>
                <Link component={RouterLink} to="/contact" color="inherit" sx={{ textDecoration: 'none' }}>
                  Contact Us
                </Link>
                <Link component={RouterLink} to="/search" color="inherit" sx={{ textDecoration: 'none' }}>
                  Smart Search
                </Link>
                <Link component={RouterLink} to="/premium" color="inherit" sx={{ textDecoration: 'none' }}>
                  Activate Premium Access
                </Link>
                <Link component={RouterLink} to="/blog" color="inherit" sx={{ textDecoration: 'none' }}>
                  Blog
                </Link>
                <Link component={RouterLink} to="/howitwork" color="inherit" sx={{ textDecoration: 'none' }}>
                  How It Works
                </Link>
              </Box>
            </Grid>

            {/* Connect Column */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Connect
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                <IconButton 
                  href="https://facebook.com/larrvaries" 
                  target="_blank"
                  color="inherit"
                >
                  <FacebookIcon />
                </IconButton>
                <IconButton 
                  href="https://twitter.com/larrvaries" 
                  target="_blank"
                  color="inherit"
                >
                  <TwitterIcon />
                </IconButton>
                <IconButton 
                  href="https://linkedin.com/company/larrvaries" 
                  target="_blank"
                  color="inherit"
                >
                  <LinkedInIcon />
                </IconButton>
              </Box>

              {/* Newsletter Subscription */}
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Newsletter
              </Typography>
              <Box 
                component="form" 
                onSubmit={(e) => {
                  e.preventDefault();
                  // Handle form submission
                }}
                sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #ffffff',
                    color: '#ffffff',
                    padding: '8px 12px',
                    width: '100%',
                    borderRadius: 0,
                    outline: 'none'
                  }}
                />
                <button
                  type="submit"
                  style={{
                    backgroundColor: '#FFD700',
                    color: '#000000',
                    border: 'none',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    width: '100%',
                    borderRadius: 0,
                    textTransform: 'uppercase',
                    fontWeight: 'bold'
                  }}
                >
                  Subscribe
                </button>
              </Box>
            </Grid>

            {/* About Larrvaries Column */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                About Larrvaries
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Larrvaries has always stood for innovation and knowledge sharing. We help everyone 
                become more knowledgeable and confident in applying what they learn. Whether it's to 
                master new technologies, advance in their careers, or develop creative skills, people 
                who rely on Larrvaries trust it to learn the critical skills and relevant information 
                necessary for success.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Bottom Bar */}
      <Box sx={{ bgcolor: '#1A1A1A', py: 2, color: '#fff' }}>
        <Container maxWidth="lg">
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2 
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                component="img"
                src={logo}
                alt="Larrvaries Logo"
                sx={{ 
                  height: 30,
                  filter: 'brightness(0) invert(1)', // Makes the logo white
                }}
              />
              <Typography variant="body2" color="inherit">
                {new Date().getFullYear()} Larrvaries Inc. All rights reserved.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 3 }}>
              <Link component={RouterLink} to="/terms" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                Terms of Use
              </Link>
              <Link component={RouterLink} to="/privacy" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/cookie-settings" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                Cookie Settings
              </Link>
              <Link component={RouterLink} to="/do-not-sell" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                Do Not Sell My Personal Info
              </Link>
              <Link component={RouterLink} to="/blog" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                Blog
              </Link>
              <Link component={RouterLink} to="/howitwork" color="inherit" sx={{ textDecoration: 'none', fontSize: '0.875rem' }}>
                How It Works
              </Link>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
